const toggleActive = require('./toggle-active.js');
const mask = require('./mask.js');

module.exports = {
	toggleActive,
	mask
};
